module.exports = __webpack_public_path__ + "img/HALAL.8c7ed3dd.png";